module.exports = __webpack_public_path__ + "img/Tabasco.90e164f2.webp";